/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSquareInSquare: {
  name: 'square-in-square';
  data: string;
} = {
  name: 'square-in-square',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H5Zm1 16V6h12v12H6Zm4-9a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-4Z" fill="currentColor"/></svg>`,
};
